import React from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error
import collectFPS from 'collect-fps';
export var AnimationControlContext = /*#__PURE__*/React.createContext({
  disableAnimations: false,
  onStartFpsCollection: () => {}
});
export var AnimationControlConsumer = AnimationControlContext.Consumer;
export var useAnimationControl = () => React.useContext(AnimationControlContext);
class AnimationControlProvider extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      disabled: props.disableAnimations || false,
      endFpsCollection: null
    };
    this.onStartFpsCollection = this.onStartFpsCollection.bind(this);
    this.onEndFpsCollection = this.onEndFpsCollection.bind(this);
  }
  onStartFpsCollection() {
    var {
      disabled,
      endFpsCollection
    } = this.state;
    if (disabled === false && endFpsCollection === null) {
      try {
        this.setState({
          endFpsCollection: collectFPS()
        });
      } catch (e) {
        // hello darkness my old friend
      }
    }
  }
  onEndFpsCollection() {
    var {
      endFpsCollection
    } = this.state;
    if (endFpsCollection !== null) {
      var fps = endFpsCollection();
      this.setState({
        disabled: fps < this.props.fpsThreshold
      });
    }
  }
  getChildContext() {
    return {
      disableAnimations: this.state.disabled,
      onStartFpsCollection: this.onStartFpsCollection,
      onEndFpsCollection: this.onEndFpsCollection
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(AnimationControlContext.Provider, {
      value: {
        disableAnimations: this.state.disabled,
        onStartFpsCollection: this.onStartFpsCollection,
        onEndFpsCollection: this.onEndFpsCollection
      }
    }, this.props.children);
  }
}
AnimationControlProvider.displayName = 'AnimationControlProvider';
AnimationControlProvider.defaultProps = {
  disableAnimations: false,
  fpsThreshold: 30
};
AnimationControlProvider.childContextTypes = {
  // @ts-expect-error
  disableAnimations: PropTypes.bool,
  // @ts-expect-error
  onStartFpsCollection: PropTypes.func,
  // @ts-expect-error
  onEndFpsCollection: PropTypes.func
};
export default AnimationControlProvider;
//# sourceMappingURL=index.js.map